var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"60px"}},[_c('b-img',{attrs:{"center":"","src":"logo.png","alt":"Logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }